import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ProductListing from "../../../components/custom/search/ProductListing";
import CategoryFilter from "../../../components/custom/search/CategorySelector";
import { ImportButton } from "../../../components/custom/import/ImportButton";
import { PageContainer } from "../../../components/core/basic/PageContainer";
import { VStack } from "../../../../styled-system/jsx";
import { usePricingConfiguration } from "../../../modules/pricingv2/api/usePricingConfiguration";
import { useSimpleCan } from "../../../config/casl/casl";

/**
 * This view implements a product search page that supports basic querying
 * and filtering.
 */
const Search = () => {
  const { t } = useTranslation(["pricingv2"]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [importPOModel, setImportPOModel] = useState(false);

  const pricingConfigQuery = usePricingConfiguration();
  const hasInventoryModule = pricingConfigQuery.data?.use_incoming_inventory;

  const userCanUpdateProducts = useSimpleCan("update", "Product");

  return (
    <PageContainer css={{ flexWrap: "wrap", flexDirection: "row" }}>
      <VStack flex={"1"} alignItems={"stretch"} minWidth={"250px"} height="100%">
        {userCanUpdateProducts && <ImportButton showDownloadTemplate={true} />}
        {hasInventoryModule && userCanUpdateProducts && (
          <ImportButton
            defaultType={`product_po_history`}
            importModalOpen={importPOModel}
            setImportModalOpen={setImportPOModel}
            title={t(($) => $.pricingv2["Upload Incoming Inventory"])}
          />
        )}

        <CategoryFilter currentCategory={selectedCategory} onCategorySelected={setSelectedCategory} />
      </VStack>
      <VStack flex={"3"} alignItems={"stretch"} minWidth={"400px"} height="100%">
        <ProductListing currentCategory={selectedCategory} key={selectedCategory} />
      </VStack>
    </PageContainer>
  );
};

export const Route = createFileRoute("/_authenticated/user/categorymanagement")({
  component: Search,
  staticData: { application: "Product" },
});
